import { HandleProfessionListUseCaseInterface } from 'domain/usecases';
import { useCallback, useState } from 'react';

import { notifyError } from '../components/notify';
import { useService } from './useService';

export const useProfession = () => {
  const { professionService } = useService();

  const [professionList, setProfessionList] =
    useState<HandleProfessionListUseCaseInterface.Result>();

  const requestGetProfession = useCallback(
    async (params: HandleProfessionListUseCaseInterface.Params) => {
      return professionService
        .getProfessionList(params)
        .then((res) => {
          setProfessionList(res);
        })
        .catch((err) => {
          notifyError(err.message);
        });
    },
    [],
  );
  return { requestGetProfession, setProfessionList, professionList };
};
